<template>
  <TheHeader />
  <el-container>
    <el-slide class="el-slider" v-if="route.path != '/setting'">
      <TheSlider/>
    </el-slide>
    <el-main>
      <div class="main_content">
        <div class="router_nav" v-if="['reportIndex_v2','base_v2','func_v2', 'func_expand_v2', 'single_trip_v2','evaluation_v2','first_v2','funcVideo_v2','MultiAnalyse_v2','single_search_v2'].indexOf(cur_route.name)>-1">
          <router-link class="router_back" :to="{
            path:'/v2/rank/'+rank_id,
          }"></router-link>
          <template v-if="['reportIndex_v2','base_v2','func_v2','func_expand_v2', 'single_trip_v2','evaluation_v2','first_v2','funcVideo_v2','single_search_v2'].indexOf(cur_route.name)>-1">
            <div class="router_model">
              <div class="model_img">
                <img :src="cur_route.model_img">
              </div>
              <div class="model_name">
                {{cur_route.model_name}}
              </div>
            </div>
            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='reportIndex_v2'?'act':''"
              :to="{
                path:'/v2/report/index',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id
                }
              }"  
            >
              <div class="nav_item_icon icon_clgk"></div>
              <div class="nav_item_text">车辆概况</div>
            </router-link>
            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='base_v2'?'act':''"
              :to="{
                path:'/v2/contrast/analyse/base',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id
                }
              }"  
            >
              <div class="nav_item_icon icon_xnwd"></div>
              <div class="nav_item_text">性能维度</div>
            </router-link>
            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='func_v2'?'act':''"
              :to="{
                path:'/v2/contrast/analyse/func',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id
                }
              }"  
            >
              <div class="nav_item_icon icon_gnwd"></div>
              <div class="nav_item_text">功能维度</div>
            </router-link>

            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='func_expand_v2'?'act':''"
              :to="{
                path:'/v2/contrast/analyse/func_expand',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id
                }
              }"  
            >
              <div class="nav_item_icon icon_gnwd"></div>
              <div class="nav_item_text">功能维度(新)</div>
            </router-link>

            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='single_trip_v2'?'act':''"
              :to="{
                path:'/v2/contrast/analyse/trip',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id
                }
              }"  
            >
              <div class="nav_item_icon icon_ltcj"></div>
              <div class="nav_item_text">旅途场景</div>
            </router-link>
            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='evaluation_v2'?'act':''"
              :to="{
                path:'/v2/contrast/evaluation',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id,
                  model_ids:'[]'
                }
              }"  
            >
              <div class="nav_item_icon icon_cxx"></div>
              <div class="nav_item_text">创新项</div>
            </router-link>
            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='first_v2'?'act':''"
              :to="{
                path:'/v2/summary/first',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id,
                }
              }"  
            >
              <div class="nav_item_icon icon_bgfx"></div>
              <div class="nav_item_text">标杆分析</div>
            </router-link>
            <router-link 
              class="router_nav_item"
              :class="cur_route.name=='funcVideo_v2'?'act':''"
              :to="{
                path:'/v2/funcVideo',
                query:{
                  model_img:cur_route.model_img,
                  model_name:cur_route.model_name,
                  model_id:cur_route.model_id,
                  report_id:cur_route.report_id
                }
              }"  
            >
              <div class="nav_item_icon icon_hxcj"></div>
              <div class="nav_item_text">核心场景</div>
            </router-link>
          </template>
          <template v-else>
            <div class="router_name">
              {{cur_route.text}}
            </div>
          </template>
        </div>
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </el-main>
  </el-container>
  
  

</template>

<script>
// @ is an alias to /src
import { useRoute, useRouter } from "vue-router";
import { ref, watch } from "vue";
import TheHeader from "@/components/common/views/TheHeader.vue";
import TheSlider from "@/components/v2/common/views/TheSlider.vue";

export default {
  name: "home_cockpit",
  components: {
    TheHeader,
    TheSlider
  },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const cur_route = ref({
      name:route.name,
      text:route.meta.name
    });
    const getCurRoute = () => {
      let {model_name,model_img,model_id,report_id}=route.query;
      cur_route.value = {
        name:route.name,
        text:route.meta.name,
        model_name,
        model_img,
        model_id,
        report_id
      };
      
      console.log(cur_route.value)
    };
    getCurRoute();
    const rank_id = ref(0);
    
    watch(route, () => {
      getCurRoute();
      rank_id.value = localStorage.getItem("zc_rank_id") || 0;
    });

    const goBack = () => {
      router.go(-1);
    };

    return {
      // matchedArr,
      cur_route,
      goBack,
      route,
      rank_id
    };
  },
};
</script>
<style lang="less" scoped>
.el-slider{
  flex-shrink: 0;
  width: 190px;
  height: 100%;
  z-index: 10;
  overflow-x: hidden;
  overflow-y: auto;
}
.home_box {
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  background: #fafafa;
}

.el-container {
  width: 100%;
  overflow: hidden;
}
.el-main {
  background: #fafafa;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 10px 0 30px 10px;
  overflow-y: auto;
  overflow-x: auto;
}

.my_breadcrumb {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  font-size: 16px;
}
.my_breadcrumb span {
  color: #777c89;
}
.main_content {
  display: inline-block;
  min-width: 1090px;
}

.go_back_btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 39px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  font-size: 12px;
  color: #676767;
  margin-right: 20px;
  .go_back_btn_icon {
    width: 20px;
    height: 20px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/chakanxiangqing_right.png) no-repeat center center;
    background-size: 6px;
    transform: rotate(180deg);
    margin-right: 6px;
  }
}
:deep(.el-drawer__close-btn) {
  transform: scale(1.5);
}

.router_nav{
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .router_back{
    cursor: pointer;
    width: 18px;
    height: 13px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/back_20230221.svg);
    background-size: 100%;
    margin-right: 27px;
  }
  .router_model{
    display: flex;
    align-items: center;
    margin-right: 30px;
    .model_img{
      width: 80px;
      height: 50px;
      img{
        width:100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .model_name{
      font-size: 14px;
      font-weight: bold;
      color: #010000;
    }
  }
  .router_nav_item{
    height: 40px;
    padding: 0 13px;
    display: flex;
    align-items: center;
    margin-right: 8px;
    cursor: pointer;
    .nav_item_icon{
      width: 20px;
      height: 20px;
      margin-right: 4px;
      &.icon_clgk{
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/clgk_20230221.svg) no-repeat center center;
        background-size: 18px;
      }
      &.icon_xnwd{
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/xnwd_20230221.svg) no-repeat center center;
        background-size: 17px;
      }
      &.icon_gnwd{
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gnwd_20230221.svg) no-repeat center center;
        background-size: 18px;
      }
      &.icon_ltcj{
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ltcj_20230221.svg) no-repeat center center;
        background-size: 13px;
      }
      &.icon_cxx{
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cxx_20230221.svg) no-repeat center center;
        background-size: 12px;
      }
      &.icon_bgfx{
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/bgfx_20230221.svg) no-repeat center center;
        background-size: 15px;
      }
      &.icon_hxcj{
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/hxcj_20230221.svg) no-repeat center center;
        background-size: 16px;
      }
    }
    .nav_item_text{
      font-size: 14px;
      color: #010000;
    }
    &.act{
      background: #1FBCBF;
      border-radius: 2px;
      .nav_item_icon{
        &.icon_clgk{
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/clgk2_20230221.svg) no-repeat center center;
          background-size: 18px;
        }
        &.icon_xnwd{
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/xnwd2_20230221.svg) no-repeat center center;
          background-size: 17px;
        }
        &.icon_gnwd{
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gnwd2_20230221.svg) no-repeat center center;
          background-size: 18px;
        }
        &.icon_ltcj{
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ltcj2_20230221.svg) no-repeat center center;
          background-size: 13px;
        }
        &.icon_cxx{
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cxx2_20230221.svg) no-repeat center center;
          background-size: 12px;
        }
        &.icon_bgfx{
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/bgfx2_20230221.svg) no-repeat center center;
          background-size: 15px;
        }
        &.icon_hxcj{
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/hxcj2_20230221.svg) no-repeat center center;
          background-size: 16px;
        }
      }
      .nav_item_text{
        color: #fff;
      }
    }
  }
  .router_name{
    color: #777c89;
    font-size: 14px;
  }
}
</style>